import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-success_1297f076ff93c13cd4f77075c0e563e4",
  "use": "ic-success_1297f076ff93c13cd4f77075c0e563e4-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol viewBox=\"0 0 80 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-success_1297f076ff93c13cd4f77075c0e563e4\">\n<circle cx=\"40\" cy=\"40\" r=\"40\" fill=\"#EBF6EB\" />\n<path d=\"M33.3329 49.267L24.0662 40.0003L20.9106 43.1336L33.3329 55.5559L59.9995 28.8892L56.8662 25.7559L33.3329 49.267Z\" fill=\"#008908\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol